<div class="dialog">
    <div class="dialog-header">指定回复人</div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row validate">
                <div class="column background-page text-right" [style.width]="80 + 'px'">
                    <span class="color-danger">*</span> 回复人
                </div>
                <div class="column" [style.width]="560 + 'px'">
                    <nz-cascader [nzOptions]="userTreeNode" [(ngModel)]="unitCascaderValue" [nzShowSearch]="true"
                        [nzPlaceHolder]="'选择回复人（可输入岗位或姓名搜索）'" [nzAllowClear]="true">
                    </nz-cascader>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
    </div>
</div>